import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

const signupSearchSchema = z.object({
  token: z.string().optional(),
})

export const Route = createFileRoute('/auth/signup')({
  validateSearch: signupSearchSchema,
  beforeLoad: ({ search }) => {
    if (search.token) {
      throw redirect({
        to: '/auth/invite',
        search: { token: search.token },
      })
    }
    throw redirect({ to: '/' })
  },
  component: () => null,
})
